"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionSearchPayload = void 0;
var BulkActionSearchPayload;
(function (BulkActionSearchPayload) {
    let parentType;
    (function (parentType) {
        parentType["SYSTEM"] = "system";
        parentType["GROUP"] = "group";
    })(parentType = BulkActionSearchPayload.parentType || (BulkActionSearchPayload.parentType = {}));
    let entityType;
    (function (entityType) {
        entityType["ACCOUNT"] = "account";
        entityType["ADVERTISER"] = "advertiser";
        entityType["CAMPAIGN"] = "campaign";
        entityType["GROUP"] = "group";
        entityType["DEPLOYMENT"] = "deployment";
    })(entityType = BulkActionSearchPayload.entityType || (BulkActionSearchPayload.entityType = {}));
})(BulkActionSearchPayload = exports.BulkActionSearchPayload || (exports.BulkActionSearchPayload = {}));
